import { Box, Grid2 } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import { StarBulletsPointsWithHeading } from '../../shared/components/StarBulletsPoints'
import { AiEdgeImages } from '../../assets/img/aiedge/AiEdgeImages'
import CustomDivider from '../../shared/utils/CustomDivider'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const ParentTrustLataaSection = ({ parentTrustData }) => {
    // const parentTrustData = [

    //     {
    //         listItemTitle: "Consistent Growth",
    //         listItemContent: "Ensures clarity and consistency in learning"
    //     },
    //     {
    //         listItemTitle: "Independent Learning",
    //         listItemContent: "Reduces dependency on tuition or extra coaching"
    //     },
    //     {
    //         listItemTitle: "Confident Learners",
    //         listItemContent: "Supports academic confidence and independent thinking"
    //     },
    //     {
    //         listItemTitle: "Visible Progress",
    //         listItemContent: "Shows visible improvements through structured, data-driven support"
    //     },
    // ]
    return (
        <Box>

            <Heading Heading={parentTrustData?.subheading} SubHeading={parentTrustData?.heading} />
            <CustomDivider />
            <Grid2 container spacing={"1rem"}>

                <Grid2
                    size={{ xs: 12, sm: 6, md: 5 }}

                    sx={{

                        borderRadius: "1rem",

                        position: "relative",

                        background: "linear-gradient(180deg, #FFDB93 0%, #FFA900 100%)",
                        height: { xs: 300, sm: "auto", md: "auto" }
                    }}
                >
                    <Box component={"img"}
                        //  src={AiEdgeImages.FatherSonImage2}
                        src={getImageUrl(parentTrustData?.trustResons?.[0]?.imageUrl)}

                        sx={{
                            width: "65%",
                            position: "absolute",
                            bottom: 0,
                            left: "50%",
                            transform: "translateX(-50%)",
                        }}
                    />

                </Grid2>




                <Grid2
                    size={{ xs: 12, sm: 6, md: 7 }}
                    sx={{
                        display: "flex",
                        alignItems: "stretch",

                        pt: 2
                    }}
                >

                    <StarBulletsPointsWithHeading items={parentTrustData?.trustResons?.[0]?.list} />
                </Grid2>
            </Grid2>

        </Box>



    )
}

export default ParentTrustLataaSection
